<template>
  <edi-dropdown-modal class="reply-wrapper">
    <div class="reply-info">

      <div class="comment-header">
        <img class="author-img" src="userAvatarUrl" alt=" ">
        <div class="comment-header-wrapper">
          <div class="author-info">
            <div class="header-title">
              <span class="num">#{{num}}</span>
              <a @click.stop :href="userProfile(userProfileUrl)" class="author-name">{{userNick}}</a>
            </div>
            <p class="publicationDate">{{publicationDate|formatDate}}</p>
          </div>
        </div>
      </div>

      <div class="comment-text">
        <p class="text">{{ text }}</p>
      </div>

      <div class="reply-footer">
        <edi-close-icon @click="$emit('close')" />
      </div>
    </div>
  </edi-dropdown-modal>
</template>

<script>
  import {mapGetters} from 'vuex';
  import { EdiDropdownModal, EdiCloseIcon } from '../../../components';

  export default {
    components: {
      EdiDropdownModal,
      EdiCloseIcon
    },
    props: {
      comment: Object
    },
    computed: {
      ...mapGetters([
        'userProfile'
      ]),
      num() {
        return this.comment?.threadRelativeCommentId;
      },
      userNick() {
        return this.comment?.userName;
      },
      userProfileUrl() {
        return this.comment?.user.profileUrl;
      },
      publicationDate() {
        const publicationDate = this.comment?.publicationDate?.date;
        return publicationDate ? publicationDate : this.comment?.publicationDate;
      },
      text() {
        return this.comment?.text;
      },
      userAvatarUrl() {
        const userAvatarUrl = this.comment?.user.avatarUrl;
        return userAvatarUrl ? userAvatarUrl : "/assets/img/default-user-avatar.png";
      }
    },
  }
</script>
